import { FAVORITES_SECTION_ID, type ReportSection } from './mock/reports';

export type ReportLibrarySectionOrders = Record<string, string[]>;

export function applyReportLibrarySectionOrders(
    sections: ReportSection[],
    sectionOrders: ReportLibrarySectionOrders,
): ReportSection[] {
    return sections.map((section) => {
        const savedIds = sectionOrders[section.id];
        if (section.id === FAVORITES_SECTION_ID || !savedIds?.length) {
            return section;
        }

        const reportsById = new Map(section.reports.map((report) => [report.id, report]));
        const usedIds = new Set<string>();
        const orderedReports: ReportSection['reports'] = [];

        for (const reportId of savedIds) {
            const report = reportsById.get(reportId);
            if (!report) {
                continue;
            }

            orderedReports.push(report);
            usedIds.add(reportId);
        }

        for (const report of section.reports) {
            if (!usedIds.has(report.id)) {
                orderedReports.push(report);
            }
        }

        return {
            ...section,
            reports: orderedReports,
        };
    });
}

export function applyReportLibrarySectionListOrder(
    sections: ReportSection[],
    savedSectionIds: string[],
): ReportSection[] {
    const favorites = sections.find((section) => section.id === FAVORITES_SECTION_ID);
    const movableSections = sections.filter((section) => section.id !== FAVORITES_SECTION_ID);

    if (!savedSectionIds.length) {
        return favorites ? [favorites, ...movableSections] : movableSections;
    }

    const sectionsById = new Map(movableSections.map((section) => [section.id, section]));
    const usedIds = new Set<string>();
    const orderedSections: ReportSection[] = [];

    for (const sectionId of savedSectionIds) {
        if (sectionId === FAVORITES_SECTION_ID) {
            continue;
        }

        const section = sectionsById.get(sectionId);
        if (!section) {
            continue;
        }

        orderedSections.push(section);
        usedIds.add(sectionId);
    }

    for (const section of movableSections) {
        if (!usedIds.has(section.id)) {
            orderedSections.push(section);
        }
    }

    return favorites ? [favorites, ...orderedSections] : orderedSections;
}
